import { useMemo, useState, useCallback, useEffect } from 'react';

export const usePaginatedFilter = ({
  data = [],
  itemsPerPage = 10,
  initialSearch = '',
  filterFn = (collection, term) => collection,
} = {}) => {
  const [searchTerm, setSearchTerm] = useState(initialSearch);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(itemsPerPage);

  const filteredData = useMemo(() => {
    return filterFn(data, searchTerm);
  }, [data, filterFn, searchTerm]);

  const totalCount = filteredData.length;
  const totalPages = Math.max(1, Math.ceil(totalCount / rowsPerPage));

  useEffect(() => {
    if (page > totalPages) {
      setPage(totalPages);
    }
  }, [page, totalPages]);

  const pageData = useMemo(() => {
    const startIndex = (page - 1) * rowsPerPage;
    return filteredData.slice(startIndex, startIndex + rowsPerPage);
  }, [filteredData, page, rowsPerPage]);

  const handleSearch = useCallback((term) => {
    setSearchTerm(term);
    setPage(1);
  }, []);

  const handlePageChange = useCallback((_, newPage) => {
    setPage(newPage);
  }, []);

  const handleRowsPerPageChange = useCallback((event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  }, []);

  return {
    searchTerm,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    data: pageData,
    filteredData,
    setPage,
    setSearchTerm,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
  };
};
